import React from 'react';
import { Heart, ArrowLeft, PawPrint, Dog } from "lucide-react";
import { motion } from 'framer-motion';
import BackButton from './BackButton';

const NameInputView = ({
    handleBack,
    currentPetName,
    setCurrentPetName,
    handleKeyPress,
    handleConfirmName
}) => (
    <motion.div
        key="name"
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 100 }}
        className="relative min-h-[400px] sm:min-h-[450px] flex flex-col"
    >
        {/* Name Input View Header */}
        <div className="relative p-6 sm:p-8 text-center border-b bg-gradient-to-r from-amber-100/50 via-amber-50/50 to-amber-100/50">
            <BackButton onClick={handleBack} />
            <div className="mx-auto mb-4 relative">
                <motion.div
                    animate={{ scale: [1, 1.05, 1] }}
                    transition={{ duration: 2, repeat: Infinity, repeatType: "reverse" }}
                    className="w-16 h-16 sm:w-20 sm:h-20 mx-auto bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl shadow-lg flex items-center justify-center"
                >
                    <Heart className="w-10 h-10 sm:w-12 sm:h-12 text-white" />
                </motion.div>
                <motion.div
                    animate={{ y: [0, -4, 0] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="absolute -bottom-2 right-1/2 transform translate-x-10"
                >
                    <PawPrint className="w-5 h-5 sm:w-6 sm:h-6 text-amber-600" />
                </motion.div>
            </div>

            <h2 className="text-2xl sm:text-3xl font-bold text-amber-900 mb-2">
                ¿Cómo se llama?
            </h2>
            <p className="text-amber-700 text-sm sm:text-base">
                Cuéntanos el nombre de tu peludo
            </p>
        </div>

        {/* Name Input View Content */}
        <div className="flex-1 p-6 sm:p-8 flex flex-col items-center justify-center">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="w-full max-w-md space-y-8"
            >
                <div className="relative">
                    <input
                        type="text"
                        value={currentPetName}
                        onChange={(e) => setCurrentPetName(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="Escribe su nombre aquí"
                        className="w-full text-center text-xl sm:text-2xl font-medium bg-transparent 
                                 border-b-2 border-amber-200 focus:border-amber-400 
                                 py-2 px-4 outline-none transition-colors
                                 placeholder:text-gray-400"
                        autoFocus
                    />
                    {currentPetName && (
                        <motion.div
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            className="absolute right-2 top-1/2 -translate-y-1/2"
                        >
                            <PawPrint className="w-5 h-5 text-amber-500" />
                        </motion.div>
                    )}
                </div>

                <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={handleConfirmName}
                    disabled={!currentPetName.trim()}
                    className={`
                        w-full p-4 rounded-xl font-medium
                        transition-all duration-200 flex items-center justify-center gap-2
                        ${currentPetName.trim()
                            ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-md hover:shadow-lg'
                            : 'bg-gray-100 text-gray-400 cursor-not-allowed'}
                    `}
                >
                    <Dog className="w-5 h-5" />
                    <span>Comenzar análisis</span>
                </motion.button>

                <p className="text-center text-sm text-gray-500">
                    Presiona Enter o el botón para continuar
                </p>
            </motion.div>
        </div>
    </motion.div>
);

export default NameInputView;